module.exports = __webpack_public_path__ + "static/img/MIB動畫.14b2f3b9.svg";